import { Schema } from '@togglecorp/ravl';

const travelSchema: Schema[] = [
    {
        extends: 'dbentity',
        doc: {
            name: 'travel',
            description: 'Travel schema',
        },
        fields: {
            supervisor: { type: 'uint', required: true },
            supervisorDetails: { type: 'miniUser', required: true },
            alsoNotifyDetails: { type: 'miniUser' },
            ticketStatus: { type: 'string' },
            ticketByDetails: { type: 'miniUser' },
            approvalStatus: { type: 'string', required: true },
            source: { type: 'string', required: true },
            destination: { type: 'string', required: true },
            destinationType: { type: 'string', required: true },
            travelType: { type: 'string', required: true },
            travelMode: { type: 'string', required: true },
            travelDate: { type: 'string', required: true },
            returnDate: { type: 'string', required: true },
            returnToPostDate: { type: 'string', required: true },
            purpose: { type: 'string', required: true },
            advanceAmount: { type: 'number', required: true },
            isNonStaff: { type: 'boolean' },
            nonStaffData: { type: 'array.unknown' },
            remarks: { type: 'string' },
            projects: { type: 'array.uint' },
            alsoNotify: { type: 'uint' },
            ticketBy: { type: 'uint' },
            totalTravelDays: { type: 'uint', required: true },
            projectsDetails: { type: 'array.projectMini' },
        },
    },
    {
        doc: {
            name: 'travelRecords',
            description: 'Travel Records List',
        },
        fields: {
            count: { type: 'uint', required: true },
            next: { type: 'string' },
            previous: { type: 'string' },
            results: { type: 'array.travel', required: true },
        },
    },
];

export default travelSchema;
